import classNames from 'classnames';
import * as React from 'react';

import styles from './styles.module.scss';

const Spinner = (props) => (
    <svg
        className={classNames('loader', styles.rotating)}
        width={props.width || 200}
        height={props.height || 200}
        preserveAspectRatio="xMidYMid"
        style={{
            margin: 'auto',
            background: '0 0',
            display: 'block',
            shapeRendering: 'auto'
        }}
        viewBox="0 0 100 100"
        {...props}
    >
        <path fill={props.fill || '#4c48a9'} d="M10 50a40 40 0 0 0 80 0 40 42 0 0 1-80 0">
            <animateTransform
                attributeName="transform"
                dur="1s"
                keyTimes="0;1"
                repeatCount="indefinite"
                // type="rotate"
                values="0 50 51;360 50 51"
            />
        </path>
    </svg>
);

export default Spinner;
